import { Share, SquarePlus, Plus } from 'lucide-react';
import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog';

interface IosInstallInstructionsModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const steps = [
  { icon: Share, text: 'Tap the Share button in Safari’s toolbar' },
  { icon: SquarePlus, text: 'Scroll down and tap "Add to Home Screen"' },
  { icon: Plus, text: 'Tap "Add" in the top-right corner' },
];

export const IosInstallInstructionsModal = ({
  open,
  onOpenChange,
}: IosInstallInstructionsModalProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <div className="text-center mb-2">
          <div className="mx-auto mb-4">
            <img
              src="./PhytoBot_Original.png"
              alt="Dr. Phyto"
              className="h-14 mx-auto"
            />
          </div>
          <DialogTitle className="text-xl font-bold text-gray-800 mb-2">
            Add to Home Screen
          </DialogTitle>
          <p className="text-sm text-gray-600">
            Install Dr. Phyto on your iPhone for quick, full-screen access.
          </p>
        </div>

        <ol className="space-y-3">
          {steps.map(({ icon: Icon, text }, index) => (
            <li key={index} className="flex items-center gap-3">
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-orange-100 text-orange-700 text-sm font-semibold">
                {index + 1}
              </span>
              <Icon className="h-5 w-5 shrink-0 text-gray-500" />
              <span className="text-sm text-gray-700">{text}</span>
            </li>
          ))}
        </ol>

        <div className="mt-4 p-3 bg-orange-50 border border-orange-200 rounded-lg">
          <p className="text-xs text-orange-800">
            This only works in Safari — other iOS browsers don&apos;t support adding
            apps to the Home Screen.
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
};
